export function bankRequest(state = {
    fetching:false,
    fetched: false,
    error:null,
},{
    type,
    payload
}){
    
    switch(type){
        case "CREATE_BANK_START":           
        case "FETCH_BANKS_START":                                 
        case "UPDATE_BANK_START":                                 
            return {
                ...state, 
                fetching:true,
            }        
        case "CREATE_BANK_FULFILLED":           
        case "FETCH_BANKS_FULFILLED":                                 
        case "UPDATE_BANK_FULFILLED":                                 
            return {
                ...state,
                fetching:false, 
                fetched:true, 
                error: null
            }    
        case "CREATE_BANK_ERROR":
        case "FETCH_BANKS_ERROR":
        case "UPDATE_BANK_ERROR":
            return {
                ...state,
                fetching:false, 
                error:payload
            }
        default:
            return state;
    }
    
}